module.exports = __webpack_public_path__ + "img/online-payment.0107dc95.svg";